import React from "react";

import { useLocales } from "hooks";

interface PushWidgetProps {
  serviceWorkersAvailable: boolean;
  permissionState?: PermissionState;
  askForPermission: () => void;
}
export const PushWidget: React.FC<PushWidgetProps> = ({
  serviceWorkersAvailable,
  permissionState,
  askForPermission,
}) => {
  const { t } = useLocales();

  if (
    serviceWorkersAvailable === false ||
    typeof permissionState === "undefined"
  ) {
    return (
      <div className="alert alert-info" role="alert">
        {t("pushUnsupported")}
      </div>
    );
  }
  if (permissionState === "prompt") {
    const handleClick = (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
      event.preventDefault();
      askForPermission();
    };
    return (
      <p>
        <a href="#" onClick={handleClick}>
          {t("requestPush")}
        </a>
      </p>
    );
  }
  if (permissionState === "denied") {
    return (
      <div className="alert alert-warning" role="alert">
        {t("pushPermissionDenied")}
      </div>
    );
  }

  // permissionState === "granted"
  return null;
};
